import { connect } from 'react-redux'
import { GameRoom } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { settings: userSettings } = state.settings
  const { group: groupName, room: roomName } = ownProps.match.params

  return ({
    width,
    userSettings,
    groupName,
    roomName,
    cards: state.renjuBoardCards.cards
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameRoom)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameRoom.js